/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreatePhotoDocUpload = {
    filename: string;
    file: string;
    latitude?: number | null;
    longitude?: number | null;
    gps_source?: CreatePhotoDocUpload.gps_source | null;
};
export namespace CreatePhotoDocUpload {
    export enum gps_source {
        EXIF = 'exif',
        DEVICE = 'device',
    }
}

